import React from 'react';
import { connect } from 'react-redux'
import Cliente from './Cliente.jsx';
import { bindActionCreators } from 'redux';

//Importación de actions.
import * as actions from '../actions/Actions.js';


const mapStateToProps = (state) => {
  return {
    data:state.cliente,
    tarjetas: state.tarjetas
  }
}

const mapDispatchToProps = (dispatch, ownProps) => {
  return {
    actions: bindActionCreators({...actions}, dispatch)
  }
}
//Connect entre el componente y las props y actions.
const ClienteContainer = connect(mapStateToProps, mapDispatchToProps)(Cliente);

export default ClienteContainer;